import React from 'react';
import { motion } from 'framer-motion';

export default function Story() {
  return (
    <section id="story" data-testid="story-section" className="py-20 md:py-32 bg-pond text-offwhite relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[60%] h-[80%] opacity-15 pointer-events-none">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1588676509970-63fe490c3712?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxmaXNoaW5nJTIwcG9uZCUyMG5hdHVyZXxlbnwwfHx8fDE3ODEzMjY5OTN8MA&ixlib=rb-4.1.0&q=85')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-pond" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="overline text-sky mb-4">The Asana story</p>
            <h2 className="editorial-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              From a family pond
              <br />
              <em className="italic font-light text-sky">to a quiet retreat.</em>
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-6 text-offwhite/90 text-lg md:text-xl leading-relaxed">
            <p>
              <span className="editorial-display text-6xl md:text-7xl text-sky float-left mr-3 leading-none">
                A
              </span>
              sana began as a simple kayumanggi pond in the heart of Bulacan — a place where the family
              would gather, kuya guides would teach the next generation to cast, and Sundays would
              stretch into golden afternoons.
            </p>
            <p>
              Today, we're slowly opening that quiet to the public. Phase 1 is fishing-and-leisure: the
              ponds, the cabanas, the warm meals. Phase 2 — coming over the next few seasons —
              will weave in eco-cabanas, walking trails, and a small wellness retreat. Always
              local-led. Always low-impact.
            </p>
            <p className="text-sky/90 font-display text-2xl md:text-3xl italic leading-snug">
              "We're not building a resort. We're tending a place."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
